import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Post from 'flarum/forum/components/Post';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/zh-cn';  // 导入中文语言包
import 'dayjs/locale/en';     // 导入英文语言包

dayjs.extend(relativeTime);

app.initializers.add('fdt-contest', () => {
  // 处理 tagtable BBCode
  extend(Post.prototype, 'oncreate', function () {
    this.$('.TagTable').each(function () {
      const tag = $(this).data('tag');

      app.store.find('discussions', {
        filter: { tag },
        sort: "-votes",
      }).then(discussions => {
        const table = $('<table>').addClass('TagTable-Table');
        const header = $('<tr>').append(
          $('<th>').text(app.translator.trans('fdt-contest.forum.table.header.title')),
          $('<th>').text(app.translator.trans('fdt-contest.forum.table.header.likes'))
        );
        table.append(header);

        discussions.forEach(discussion => {
          const row = $('<tr>').append(
            $('<td>').append($('<a>').attr('href', app.route.discussion(discussion)).text(discussion.title())),
            $('<td>').text(discussion.attribute('votes'))
          );
          table.append(row);
        });

        $(this).append(table);
      });
    });
  });

  const currentLocale = app.translator.locale || 'en';
  dayjs.locale(currentLocale === 'zh' ? 'zh-cn' : 'en');

  // 处理 deadline BBCode
  extend(Post.prototype, 'oncreate', function () {
    this.$('.Deadline').each(function () {
      const $deadlineElement = $(this);
      const time = $deadlineElement.data('time');
      const deadlineTime = dayjs(time);

      function updateTime() {
        const currentTime = dayjs();
        const timeLeft = deadlineTime.isAfter(currentTime)
          ? deadlineTime.from(currentTime, true)
          : app.translator.trans('fdt-contest.forum.deadline.expired');

        $deadlineElement.text(`${app.translator.trans('fdt-contest.forum.deadline.label')}: ${timeLeft}`);
      }

      // 初次更新
      updateTime();

      // 每秒更新一次倒计时
      const intervalId = setInterval(updateTime, 1000);

      // 清除定时器以防止内存泄漏
      this.onremove = () => clearInterval(intervalId);
    });
  });
});